import React, { Component } from "react";  
//import Gallery from 'react-grid-gallery';
 
import Slider from 'react-slick';
import Lightbox from 'react-image-lightbox';

class CompAdmissionProcess extends Component {  
  constructor() {  
    super();  
    this.state = {  
      name: "ReactJS",
      admissioninfo: ''
    };  
  }  

   componentDidMount() {

      let admission_process = this.props.admission_process;
      let admission_link = this.props.admission_link;
      this.setState({admission_process:admission_process, admission_link:admission_link});
   }

  adlink(type, link) {
    let req = JSON.stringify({
      category_id: 121,
      page_id: this.props.match.params.id,
      customer_id: this.state.user_id,
      vendor_id: this.state.vendor_id,
      is_admission: type == 1 && true,
      is_website: type == 2 && true,
      url: 'clickcount'
    });
    commonAPI(req).then(res => {
      console.log('res', res);
    });
    window.open(
      link,
      '_blank' // <- This is what makes it open in a new window.
    );
  }

  render() {  

    const { admission_process, admission_link } = this.state;
    
    return <div id="admission_section"><h3>Admission Process</h3>
                    <div className='row n6vgl'>
                        <div className='col-md-12'>
                          <p className="mb-0">
                            <span className='n7vd6h'>Admission Link : </span>
                            <span className='ad-link'>
                              {admission_link && <span onClick={() => this.adlink(1, admission_link)} style={{ wordBreak: "break-all", cursor: 'pointer' }}>{admission_link}</span>}
                              {/* <a href={admission_link} target='_blank'><span style={{ wordBreak: "break-all" }}>{admission_link}{' '}</span></a> */}
                            </span>
                          </p>
                          <p>
                            <span className='n7vd6h'>Admission Process :</span>{' '}
                            <span className='m8bx4bg'>{admission_process}</span>
                          </p>
                        </div>
                      </div>
          </div>
  }  
}  
   
export default CompAdmissionProcess;